export default "__VITE_PUBLIC_ASSET__32b6e018__"